module.exports = __webpack_public_path__ + "img/dead.efa97154.png";